import { useState, useEffect, useCallback } from 'react';
import { CHANGE_PAGE_LIMIT, CHANGE_PAGE } from 'constants/ActionTypes';
import { useDispatch } from 'react-redux';

export default function usePagination() {
  const dispatch = useDispatch();
  const [resource, setResource] = useState(null);
  const [page, setPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [pageLimitOptions, setPageLimitOptions] = useState([10, 20, 50, 100]);

  const handlePageLimitChange = useCallback(
    (value, resourceType) => {
      setPageLimit(value);
      setResource(resourceType);
    },
    [setPageLimit, setResource],
  );

  const handlePageChange = useCallback(
    (value, resourceType) => {
      setPage(value);
      setResource(resourceType);
    },
    [setPage, setResource],
  );

  useEffect(() => {
    dispatch({ type: CHANGE_PAGE_LIMIT, payload: { type: resource, pageSize: pageLimit } });
    dispatch({ type: CHANGE_PAGE, payload: { type: resource, currentPage: 1 } });

    return () => {
      dispatch({ type: CHANGE_PAGE_LIMIT, payload: { type: resource, pageSize: 10 } });
    };
  }, [pageLimit]);

  useEffect(() => {
    dispatch({ type: CHANGE_PAGE, payload: { type: resource, currentPage: page } });

    return () => {
      dispatch({ type: CHANGE_PAGE, payload: { type: resource, currentPage: 1 } });
    };
  }, [page]);

  return {
    pageLimit,
    pageLimitOptions,
    handlePageChange,
    handlePageLimitChange,
    setPageLimitOptions,
  };
}
